import { CSSProperties } from "react";
import { IconProps } from "./IconProps";
import money2IconPng from "./money_2_icon.png";

export const Money2Icon = ({ height = 48, width = 48, color = "#C40109" }: IconProps) => {
    const style: CSSProperties = {
        width,
        height,
        backgroundColor: color,
        display: "inline-block",
        maskImage: `url(${money2IconPng})`,
        WebkitMaskImage: `url(${money2IconPng})`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
        maskSize: "contain",
        WebkitMaskSize: "contain",
    };

    return <span aria-hidden="true" style={style} />;
};
